import {
    SchedulerViewSlot,
    SchedulerViewSlotProps,
} from '@progress/kendo-react-scheduler'
import { classNames } from 'utils/dom-helpers'

export function GViewSlot(props: SchedulerViewSlotProps) {
    return (
        <SchedulerViewSlot
            {...props}
            className={classNames(props.className || '', 'g-view-slot h-6')}
        />
    )
}

export default GViewSlot
